export type ContentType = 'movie' | 'tv' | 'variety';

export interface Movie {
  id: string;
  title: string;
  type: ContentType;
  region: string;
  year: number;
  genres: string[];
  duration: string;
  status: string;
  updateDate: string;
  rating: number;
  hot: number;
  director: string;
  actors: string[];
  cover: string;
  backdrop?: string;
  summary: string;
  synopsis: string;
}

export const contentTypeLabels: Record<ContentType, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};

export const regions: string[] = ['中国大陆', '中国香港', '中国台湾', '日本', '韩国', '泰国'];

export const years: string[] = ['全部', '2025', '2024', '2023', '2022', '2021', '2020及以前'];

export const genres: string[] = [
  '剧情', '悬疑', '动作', '犯罪', '爱情', '喜剧', '家庭', '古装', '武侠',
  '都市', '科幻', '惊悚', '医疗', '美食', '音乐', '真人秀', '访谈', '冒险',
];

export const movies: Movie[] = [
  {
    id: 'cn-long-night',
    title: '长夜将尽',
    type: 'movie',
    region: '中国大陆',
    year: 2024,
    genres: ['剧情', '悬疑'],
    duration: '118 分钟',
    status: '已完结',
    updateDate: '2024-11-08',
    rating: 8.6,
    hot: 9820,
    director: '陈守拙',
    actors: ['沈知白', '林晚舟', '周砚明'],
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20moody%20movie%20poster%20of%20a%20lone%20figure%20standing%20under%20rain%20on%20a%20dark%20city%20street%20at%20midnight%2C%20deep%20navy%20blue%20tones%20with%20warm%20amber%20street%20lamp%20glow%2C%20atmospheric%20fog%2C%20dramatic%20side%20lighting%2C%20minimalist%20composition%2C%20premium%20artistic%20film%20poster%20style%2C%20no%20text&width=400&height=600&seq=mv-cn-long-night&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20rainy%20neon%20lit%20metropolitan%20alleyway%20at%20night%2C%20deep%20navy%20blue%20atmosphere%20with%20amber%20highlights%2C%20silhouettes%20of%20a%20lonely%20figure%2C%20volumetric%20fog%20and%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=1200&height=675&seq=bd-cn-long-night&orientation=landscape',
    summary: '一桩尘封多年的旧案，在漫长的雨夜里被重新翻开。',
    synopsis: '本片讲述了失意警探在雨夜追查一桩尘封旧案的故事。随着线索层层剥开，他发现真相与自己的过去紧密相连。影片以冷峻的影像风格与克制的情感表达，探讨了救赎与执念之间的抉择，画面与配乐共同营造出强烈的沉浸感，中文字幕完整呈现每一处细节。',
  },
  {
    id: 'hk-wind-south',
    title: '风起南洋',
    type: 'movie',
    region: '中国香港',
    year: 2023,
    genres: ['动作', '犯罪'],
    duration: '132 分钟',
    status: '已完结',
    updateDate: '2023-09-20',
    rating: 8.2,
    hot: 8640,
    director: '黄镇业',
    actors: ['麦志豪', '苏咏芝', '高见鸿'],
    cover: 'https://readdy.ai/api/search-image?query=Gritty%20cinematic%20action%20movie%20poster%20of%20a%20man%20in%20a%20trench%20coat%20walking%20through%20a%20crowded%20southern%20harbor%20market%20at%20dusk%2C%20deep%20teal%20blue%20and%20amber%20color%20grading%2C%20smoke%20and%20warm%20lantern%20light%2C%20high%20contrast%20dramatic%20shadows%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=mv-hk-wind-south&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20bustling%20southern%20asian%20harbor%20market%20at%20dusk%2C%20deep%20teal%20blue%20sky%20with%20warm%20amber%20lantern%20glow%2C%20smoke%20and%20mist%2C%20dramatic%20high%20contrast%20lighting%2C%20moody%20crime%20thriller%20aesthetic%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=1200&height=675&seq=bd-hk-wind-south&orientation=landscape',
    summary: '南洋商埠的暗流之下，一场关于忠诚与背叛的博弈正在上演。',
    synopsis: '故事发生在上世纪九十年代的南洋商埠，一名卧底警员潜入走私集团，在黑白之间艰难周旋。随着局势失控，他必须在家人与正义之间做出抉择。影片的动作场面干脆利落，港式犯罪片气质浓郁，中文字幕精准还原经典对白。',
  },
  {
    id: 'jp-silent-snow',
    title: '雪落无声',
    type: 'movie',
    region: '日本',
    year: 2024,
    genres: ['剧情', '家庭'],
    duration: '126 分钟',
    status: '已完结',
    updateDate: '2024-12-01',
    rating: 8.9,
    hot: 9210,
    director: '佐藤悠介',
    actors: ['中村千鹤', '高桥直人', '松本玲奈'],
    cover: 'https://readdy.ai/api/search-image?query=Quiet%20cinematic%20movie%20poster%20of%20a%20woman%20in%20a%20winter%20coat%20standing%20in%20a%20snowy%20rural%20japanese%20village%20at%20dusk%2C%20soft%20pale%20blue%20and%20warm%20amber%20light%2C%20falling%20snow%2C%20minimalist%20gentle%20composition%2C%20warm%20window%20glow%20in%20distance%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=mv-jp-silent-snow&orientation=portrait',
    summary: '大雪封村的那年冬天，母女俩终于说出了藏在心里的话。',
    synopsis: '影片以细腻而克制的笔触，记录了一对母女在返乡过冬期间的和解过程。安静的镜头语言、留白式的叙事与自然的表演，让情感在沉默中层层累积。这是一部关于理解与告别的家庭剧情片，中文字幕保留原作细腻的台词节奏。',
  },
  {
    id: 'kr-seoul-night',
    title: '首尔夜行',
    type: 'movie',
    region: '韩国',
    year: 2024,
    genres: ['犯罪', '惊悚'],
    duration: '121 分钟',
    status: '已完结',
    updateDate: '2024-10-15',
    rating: 8.4,
    hot: 8970,
    director: '朴叙真',
    actors: ['姜在勋', '尹智雅', '文成浩'],
    cover: 'https://readdy.ai/api/search-image?query=Neo%20noir%20cinematic%20movie%20poster%20of%20a%20detective%20silhouette%20crossing%20a%20rain%20slick%20seoul%20intersection%20at%20night%2C%20deep%20navy%20blue%20and%20cyan%20neon%20reflections%2C%20wet%20asphalt%20glow%2C%20dramatic%20contrast%20lighting%2C%20tense%20thriller%20mood%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=mv-kr-seoul-night&orientation=portrait',
    summary: '跨年夜的首尔，一通匿名电话拉开连环案件的序幕。',
    synopsis: '一名资深刑警在跨年夜接到匿名检举，随之卷入一场跨越城市南北的追缉。影片节奏紧凑，城市夜景的霓虹与雨幕构成独特的视觉风格，结局反转令人意外。中文字幕同步呈现案件线索与对白细节。',
  },
  {
    id: 'th-bangkok-letter',
    title: '曼谷来信',
    type: 'movie',
    region: '泰国',
    year: 2023,
    genres: ['爱情', '剧情'],
    duration: '110 分钟',
    status: '已完结',
    updateDate: '2023-07-30',
    rating: 7.9,
    hot: 6450,
    director: '纳塔蓬',
    actors: ['素帕猜', '普琳蒂', '阿努查'],
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20cinematic%20movie%20poster%20of%20two%20lovers%20silhouetted%20on%20a%20bangkok%20rooftop%20at%20golden%20hour%2C%20warm%20amber%20and%20deep%20blue%20sky%2C%20city%20skyline%20bokeh%2C%20soft%20dreamy%20lighting%2C%20nostalgic%20bittersweet%20mood%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=mv-th-bangkok-letter&orientation=portrait',
    summary: '一封迟到的信，让两个错过多年的灵魂再次相遇。',
    synopsis: '影片讲述一对因误会分开的青年男女，多年后因一封未寄出的信重新联系。曼谷的城市街景与湄南河夜色构成浪漫背景，叙事温婉动人。中文字幕完整传达情感的细微波动，适合喜欢治愈系爱情题材的观众。',
  },
  {
    id: 'jp-tokyo-story',
    title: '东京物语·新章',
    type: 'movie',
    region: '日本',
    year: 2022,
    genres: ['剧情'],
    duration: '135 分钟',
    status: '已完结',
    updateDate: '2022-05-18',
    rating: 8.7,
    hot: 5230,
    director: '山田和彦',
    actors: ['小林和子', '大野修', '渡边由美'],
    cover: 'https://readdy.ai/api/search-image?query=Timeless%20family%20drama%20movie%20poster%20of%20an%20elderly%20couple%20sitting%20on%20a%20bench%20in%20a%20quiet%20tokyo%20park%20in%20autumn%2C%20muted%20warm%20amber%20and%20soft%20grey%20blue%20palette%2C%20falling%20leaves%2C%20gentle%20natural%20light%2C%20nostalgic%20composition%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=mv-jp-tokyo-story&orientation=portrait',
    summary: '一对老夫妻的城市探亲之旅，映照出时光与亲情的轮廓。',
    synopsis: '本片以一对老年夫妇前往东京探望子女的旅程为主线，用平淡却深情的日常片段，勾勒出家庭关系中的疏离与温暖。影像克制素雅，情感真挚，是经得起反复品味的剧情经典，中文字幕细腻还原日常对话。',
  },
  {
    id: 'cn-changbai-hunter',
    title: '长白山猎人',
    type: 'movie',
    region: '中国大陆',
    year: 2023,
    genres: ['冒险', '剧情'],
    duration: '124 分钟',
    status: '已完结',
    updateDate: '2023-12-12',
    rating: 8.0,
    hot: 7120,
    director: '赵北川',
    actors: ['韩振山', '柳青', '巴雅尔'],
    cover: 'https://readdy.ai/api/search-image?query=Adventure%20cinematic%20movie%20poster%20of%20a%20weathered%20hunter%20in%20heavy%20winter%20gear%20standing%20in%20a%20vast%20snow%20mountain%20forest%20at%20dawn%2C%20cold%20deep%20blue%20shadow%20and%20warm%20amber%20sunrise%2C%20pine%20trees%20and%20mist%2C%20epic%20lonely%20atmosphere%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=mv-cn-changbai-hunter&orientation=portrait',
    summary: '林海雪原之中，猎人循着足迹走进一段被遗忘的往事。',
    synopsis: '影片以长白山林区为背景，讲述一位老猎人在严冬中护送迷途少年穿越雪原的故事。辽阔的自然景观与人物内心的孤独相互映照，摄影极具张力。中文字幕细腻传达东北方言与山野生活的质感。',
  },
  {
    id: 'tw-turn-back',
    title: '回头是岸',
    type: 'movie',
    region: '中国台湾',
    year: 2024,
    genres: ['剧情', '悬疑'],
    duration: '114 分钟',
    status: '已完结',
    updateDate: '2024-08-25',
    rating: 8.3,
    hot: 6890,
    director: '许明洲',
    actors: ['吴承宇', '林语桐', '郑允安'],
    cover: 'https://readdy.ai/api/search-image?query=Reflective%20cinematic%20movie%20poster%20of%20a%20young%20man%20standing%20at%20the%20edge%20of%20a%20small%20coastal%20taiwanese%20harbor%20at%20blue%20hour%2C%20deep%20navy%20sea%20and%20warm%20amber%20distant%20lights%2C%20misty%20calm%20mood%2C%20minimal%20composition%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=mv-tw-turn-back&orientation=portrait',
    summary: '一个关于选择与救赎的故事，从海边的那个黄昏开始。',
    synopsis: '男主角在人生的岔路口回到故乡海边，试图弥补多年前的一次错误决定。影片以台湾小镇的海岸风光为舞台，叙事沉稳而充满人文关怀。中文字幕完整保留闽南语与普通话交织的对白韵味。',
  },
  {
    id: 'cn-sea-flowers',
    title: '海上繁花',
    type: 'tv',
    region: '中国大陆',
    year: 2024,
    genres: ['都市', '爱情'],
    duration: '共 40 集',
    status: '更新至 32 集',
    updateDate: '2024-12-10',
    rating: 8.1,
    hot: 9450,
    director: '苏瑾瑜',
    actors: ['顾星辰', '白鹿笙', '陆铭轩'],
    cover: 'https://readdy.ai/api/search-image?query=Modern%20drama%20series%20poster%20of%20an%20elegant%20young%20woman%20standing%20on%20a%20waterfront%20terrace%20at%20sunset%2C%20warm%20amber%20light%20and%20deep%20blue%20sea%2C%20city%20skyline%20bokeh%2C%20refined%20urban%20romantic%20mood%2C%20soft%20cinematic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=tv-cn-sea-flowers&orientation=portrait',
    summary: '繁华都市的海边，一段势均力敌的爱情悄然生长。',
    synopsis: '剧集聚焦一群在滨海都市打拼的年轻人，讲述他们在事业与爱情之间的成长与抉择。人物关系细腻真实，都市质感与情感张力兼具。中文字幕同步更新，带你完整体验每一段动人情节。',
  },
  {
    id: 'cn-silent-truth',
    title: '沉默的真相线',
    type: 'tv',
    region: '中国大陆',
    year: 2024,
    genres: ['悬疑', '犯罪'],
    duration: '共 24 集',
    status: '已完结',
    updateDate: '2024-11-28',
    rating: 9.1,
    hot: 10120,
    director: '何未然',
    actors: ['秦墨白', '方可遇', '黎仲恺'],
    cover: 'https://readdy.ai/api/search-image?query=Dark%20suspense%20series%20poster%20of%20a%20detective%20studying%20a%20wall%20of%20evidence%20photos%20in%20a%20dim%20office%2C%20deep%20navy%20blue%20shadow%20with%20warm%20amber%20desk%20lamp%2C%20mysterious%20tense%20mood%2C%20high%20contrast%20cinematic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=tv-cn-silent-truth&orientation=portrait',
    summary: '当所有证据都指向沉默，真相藏在最不起眼的细节里。',
    synopsis: '该剧围绕一起多年悬案展开，刑警团队在纷繁线索中抽丝剥茧，最终揭开被时间掩埋的真相。剧本扎实、表演内敛，氛围营造出强烈的代入感。中文字幕精准呈现案件推理的每一个关键节点。',
  },
  {
    id: 'cn-palace-willow',
    title: '宫墙柳',
    type: 'tv',
    region: '中国大陆',
    year: 2023,
    genres: ['古装', '剧情'],
    duration: '共 46 集',
    status: '已完结',
    updateDate: '2023-11-05',
    rating: 8.5,
    hot: 8320,
    director: '温静姝',
    actors: ['叶清妍', '谢承轩', '孟婉宁'],
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20period%20drama%20poster%20of%20a%20woman%20in%20traditional%20chinese%20hanfu%20standing%20before%20a%20palace%20walled%20courtyard%20with%20willow%20trees%2C%20deep%20blue%20twilight%20and%20warm%20amber%20lanterns%2C%20falling%20petals%2C%20refined%20melancholic%20mood%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=tv-cn-palace-willow&orientation=portrait',
    summary: '深宫之中，一株宫墙柳见证了无数无声的悲欢。',
    synopsis: '本剧以古代后宫为背景，讲述一位聪慧女子在权力与情感之间周旋成长的故事。服化道考究，人物刻画立体，权谋与情感线交织推进。中文字幕完整呈现典雅台词，带你沉浸式体验古典美学。',
  },
  {
    id: 'jp-convenience-night',
    title: '便利店之夜',
    type: 'tv',
    region: '日本',
    year: 2024,
    genres: ['家庭', '生活'],
    duration: '共 10 集',
    status: '已完结',
    updateDate: '2024-09-18',
    rating: 8.6,
    hot: 6240,
    director: '森田凉子',
    actors: ['石川遥', '木下健太', '藤原沙罗'],
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20slice%20of%20life%20series%20poster%20of%20a%20small%20japanese%20convenience%20store%20glowing%20warm%20amber%20at%20night%20on%20a%20quiet%20street%2C%20deep%20blue%20evening%20sky%2C%20a%20lone%20clerk%20silhouette%20inside%2C%20warm%20gentle%20mood%2C%20soft%20cinematic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=tv-jp-convenience-night&orientation=portrait',
    summary: '深夜便利店，每个进店的客人都带着一段小故事。',
    synopsis: '剧集以一家深夜便利店为舞台，用温暖细腻的单元叙事，讲述店员与往来客人之间不期而遇的善意。节奏舒缓、治愈感十足，适合深夜观看。中文字幕细腻还原生活化对白。',
  },
  {
    id: 'cn-jiangnan-rain',
    title: '江南烟雨录',
    type: 'tv',
    region: '中国大陆',
    year: 2024,
    genres: ['古装', '武侠'],
    duration: '共 36 集',
    status: '更新至 28 集',
    updateDate: '2024-12-05',
    rating: 8.4,
    hot: 8790,
    director: '柳乘风',
    actors: ['苏含章', '顾清梧', '裴行之'],
    cover: 'https://readdy.ai/api/search-image?query=Wuxia%20period%20drama%20poster%20of%20a%20swordsman%20in%20flowing%20robes%20standing%20on%20a%20stone%20arch%20bridge%20in%20misty%20jiangnan%20canal%20town%20at%20rainy%20dusk%2C%20deep%20blue%20mist%20and%20warm%20amber%20lantern%20glow%2C%20willow%20branches%2C%20elegant%20martial%20arts%20mood%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=tv-cn-jiangnan-rain&orientation=portrait',
    summary: '烟雨江南，一柄剑、一壶酒，走出一段江湖传奇。',
    synopsis: '剧集以江南水乡为舞台，讲述一位身世成谜的剑客卷入武林纷争的故事。武打设计飘逸写意，画面水墨感十足，人物关系错综复杂。中文字幕完整呈现江湖对白，带你重回快意恩仇的武侠世界。',
  },
  {
    id: 'kr-backlight',
    title: '逆光而行',
    type: 'tv',
    region: '韩国',
    year: 2024,
    genres: ['都市', '剧情'],
    duration: '共 16 集',
    status: '已完结',
    updateDate: '2024-10-30',
    rating: 8.2,
    hot: 7560,
    director: '郑恩率',
    actors: ['李承宇', '韩素妍', '崔敏浩'],
    cover: 'https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20a%20young%20professional%20walking%20through%20a%20glass%20office%20tower%20corridor%20at%20dusk%20with%20backlight%2C%20deep%20navy%20blue%20and%20warm%20amber%20accents%2C%20reflective%20surfaces%2C%20sharp%20confident%20mood%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=tv-kr-backlight&orientation=portrait',
    summary: '在逆光的都市丛林里，他们选择迎难而上。',
    synopsis: '剧集聚焦几位在竞争激烈的职场中打拼的年轻人，讲述他们面对压力、坚持理想的过程。人物成长弧线清晰，台词犀利真实。中文字幕同步呈现职场术语与情感表达，观赏体验流畅。',
  },
  {
    id: 'cn-mars-orphan',
    title: '火星孤儿',
    type: 'tv',
    region: '中国大陆',
    year: 2023,
    genres: ['科幻', '剧情'],
    duration: '共 20 集',
    status: '已完结',
    updateDate: '2023-08-14',
    rating: 8.0,
    hot: 5870,
    director: '陆星河',
    actors: ['程未然', '苏墨言', '江予白'],
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20sci%20fi%20series%20poster%20of%20a%20lone%20astronaut%20silhouette%20standing%20before%20a%20mars%20colony%20dome%20under%20a%20deep%20blue%20sky%2C%20warm%20amber%20base%20lights%20and%20orange%20dust%2C%20epic%20lonely%20atmosphere%2C%20cinematic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=tv-cn-mars-orphan&orientation=portrait',
    summary: '当故乡成为远方，一群孤儿在火星上寻找归属。',
    synopsis: '剧集讲述一群在火星基地长大的年轻人，在严酷环境中探索生存意义的故事。世界观设定扎实，视效克制而有质感，情感内核温暖。中文字幕同步呈现科幻设定术语，观剧体验沉浸完整。',
  },
  {
    id: 'hk-healer-heart',
    title: '医者仁心录',
    type: 'tv',
    region: '中国香港',
    year: 2024,
    genres: ['医疗', '剧情'],
    duration: '共 30 集',
    status: '更新至 22 集',
    updateDate: '2024-11-20',
    rating: 8.3,
    hot: 6740,
    director: '梁仲衡',
    actors: ['何书晴', '卓志远', '温子澄'],
    cover: 'https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20of%20a%20dedicated%20doctor%20in%20scrubs%20standing%20in%20a%20hospital%20corridor%20at%20night%2C%20deep%20blue%20shadow%20with%20warm%20amber%20light%20spill%2C%20serene%20compassionate%20mood%2C%20clean%20cinematic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=tv-hk-healer-heart&orientation=portrait',
    summary: '在生死交界的病房里，仁心是最锋利的武器。',
    synopsis: '本剧以公立医院急诊科为舞台，讲述医护团队在高压环境下救死扶伤、守护信念的故事。病例真实动人，群像刻画饱满。中文字幕精准呈现专业医疗对白与人文关怀。',
  },
  {
    id: 'cn-mountain-food',
    title: '山海食光',
    type: 'variety',
    region: '中国大陆',
    year: 2025,
    genres: ['美食', '旅行'],
    duration: '共 12 期',
    status: '更新至 9 期',
    updateDate: '2025-01-06',
    rating: 8.8,
    hot: 7890,
    director: '林一味',
    actors: ['沈牧之', '苏小满', '林知味'],
    cover: 'https://readdy.ai/api/search-image?query=Warm%20food%20travel%20variety%20poster%20of%20a%20rustic%20outdoor%20dining%20table%20by%20a%20mountain%20lake%20at%20sunset%2C%20deep%20blue%20mountains%20and%20warm%20amber%20string%20lights%2C%20steaming%20dishes%2C%20cozy%20inviting%20mood%2C%20soft%20cinematic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=vt-cn-mountain-food&orientation=portrait',
    summary: '跟着美食家走遍山海，用一餐饭的时间认识一座城。',
    synopsis: '节目以美食与旅行为主线，带着观众走进各地的山海之间，探访地道风味与匠心厨师。画面唯美，叙事松弛治愈。中文字幕完整呈现地域方言与美食故事，是放松身心的下饭综艺。',
  },
  {
    id: 'cn-stage-generation',
    title: '唱跳新世代',
    type: 'variety',
    region: '中国大陆',
    year: 2025,
    genres: ['音乐', '真人秀'],
    duration: '共 14 期',
    status: '更新至 11 期',
    updateDate: '2025-01-12',
    rating: 8.5,
    hot: 9230,
    director: '周律动',
    actors: ['导师团', '练习生群像'],
    cover: 'https://readdy.ai/api/search-image?query=Energetic%20music%20competition%20variety%20poster%20of%20a%20spotlight%20lit%20concert%20stage%20with%20deep%20navy%20blue%20backdrop%20and%20warm%20amber%20stage%20beams%2C%20silhouettes%20of%20performers%2C%20dynamic%20vibrant%20mood%2C%20cinematic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=vt-cn-stage-generation&orientation=portrait',
    summary: '聚光灯下，新一代唱跳偶像的舞台从这里开始。',
    synopsis: '节目汇聚来自各地的年轻练习生，通过多轮舞台竞演角逐出道席位。舞台设计华丽，赛制紧张刺激。中文字幕同步呈现点评与幕后故事，让你看到每一份努力背后的坚持。',
  },
  {
    id: 'cn-go-friends',
    title: '出发吧朋友们',
    type: 'variety',
    region: '中国大陆',
    year: 2024,
    genres: ['真人秀', '旅行'],
    duration: '共 12 期',
    status: '已完结',
    updateDate: '2024-09-25',
    rating: 8.2,
    hot: 6980,
    director: '程远行',
    actors: ['常驻嘉宾团'],
    cover: 'https://readdy.ai/api/search-image?query=Fun%20travel%20reality%20show%20poster%20of%20a%20group%20of%20friends%20laughing%20around%20a%20campfire%20under%20a%20deep%20blue%20starfilled%20night%20sky%2C%20warm%20amber%20firelight%20glow%2C%20tents%20and%20mountains%2C%20joyful%20adventurous%20mood%2C%20cinematic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=vt-cn-go-friends&orientation=portrait',
    summary: '一群好朋友的旅行，笑声比风景更值得收藏。',
    synopsis: '节目邀请多位嘉宾组成旅行团，一路走走停停，体验不同城市的烟火气。互动自然真实，笑点密集。中文字幕完整呈现旅途中的趣事与真心话，轻松又治愈。',
  },
  {
    id: 'jp-late-night-radio',
    title: '深夜电台',
    type: 'variety',
    region: '日本',
    year: 2024,
    genres: ['访谈'],
    duration: '共 26 期',
    status: '更新至 18 期',
    updateDate: '2024-12-08',
    rating: 8.4,
    hot: 4120,
    director: '宫崎友和',
    actors: ['主持人', '每期嘉宾'],
    cover: 'https://readdy.ai/api/search-image?query=Intimate%20late%20night%20talk%20show%20poster%20of%20a%20warmly%20lit%20radio%20studio%20microphone%20with%20deep%20blue%20night%20window%20bokeh%20behind%2C%20amber%20lamp%20glow%2C%20cozy%20reflective%20mood%2C%20soft%20cinematic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=vt-jp-late-night-radio&orientation=portrait',
    summary: '深夜的电台里，每一次对话都像老朋友的低语。',
    synopsis: '节目在深夜时段展开深度访谈，邀请各领域嘉宾分享人生经历与创作感悟。氛围沉静真诚，内容有温度。中文字幕完整呈现每段真挚对话，适合睡前静静聆听。',
  },
  {
    id: 'kr-heart-signal',
    title: '心动信号屋',
    type: 'variety',
    region: '韩国',
    year: 2024,
    genres: ['真人秀', '爱情'],
    duration: '共 16 期',
    status: '已完结',
    updateDate: '2024-08-08',
    rating: 8.1,
    hot: 5670,
    director: '金志勋',
    actors: ['素人嘉宾群像'],
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20dating%20reality%20show%20poster%20of%20a%20cozy%20seaside%20house%20terrace%20at%20blue%20hour%20with%20warm%20amber%20string%20lights%2C%20soft%20pink%20and%20blue%20sunset%20sky%2C%20dreamy%20hopeful%20mood%2C%20cinematic%20lighting%2C%20premium%20artistic%20poster%20style%2C%20no%20text&width=400&height=600&seq=vt-kr-heart-signal&orientation=portrait',
    summary: '在一栋海边小屋里，心动的信号正悄悄发出。',
    synopsis: '节目让来自不同背景的素人嘉宾同住海边小屋，在日常相处中寻找心动。情感线自然真实，观察室点评幽默犀利。中文字幕同步呈现每一次微妙的情绪变化。',
  },
];